import React, { useState, useEffect, useRef } from 'react';
import "./LogSystem.css"
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Pagination,
    Button,
  } from "@mui/material";
  import { getLoginLogs } from "../../api/admin/loginloglist/loginlog-list"; // 경로 맞게 수정


const LogSystem = () => {
    const [logs, setLogs] = useState([]);
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [search, setSearch] = useState("");
  
    // 로그인 로그 조회
    const fetchLogs = async () => {
      try {
        const data = await getLoginLogs({
          page,
          size: 10,
          searchKeyword: search,
        });
  
        setLogs(data.content);
        setPageCount(data.totalPages);
      } catch (err) {
        console.error("로그 조회 실패:", err);
      }
    };
  
    useEffect(() => {
      fetchLogs();
    }, [page, search]);
  
    
  return (
   
      <div style={{ color: "#fff", padding: "1rem" }}>
        {/* 헤더 & 검색 */}
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "1rem" }}>
          <h2>사용자 로그</h2>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <input
            type="text"
            className='Sreach_Textfield'
              placeholder="IP 주소 입력"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button className='Search_btn' onClick={() => setPage(1)}>
              검색
            </button>
          </div>
        </div>
  
        {/* 테이블 */}
        <TableContainer component={Paper} sx={{ backgroundColor: "#2B2E3A" }}>
          <Table>
            <TableHead>
              <TableRow >
                <TableCell sx={{ color: "#BBBBBB" }}>로그 ID</TableCell>
                <TableCell sx={{ color: "#BBBBBB" }}>사용자</TableCell>
                <TableCell sx={{ color: "#BBBBBB" }}>성공 여부</TableCell>
                <TableCell sx={{ color: "#BBBBBB" }}>IP</TableCell>
                <TableCell sx={{ color: "#BBBBBB" }}>브라우저</TableCell>
                <TableCell sx={{ color: "#BBBBBB" }}>OS</TableCell>
                <TableCell sx={{ color: "#BBBBBB" }}>디바이스</TableCell>
                <TableCell sx={{ color: "#BBBBBB" }}>접속일시</TableCell>
                <TableCell sx={{ color: "#BBBBBB" }}>메모</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {logs.map((log) => (
                <TableRow key={log.loginLogId}>
                  <TableCell sx={{ color: "#fff" }}>{log.loginLogId}</TableCell>
                  <TableCell sx={{ color: "#fff" }}>{log.userName || log.userId}</TableCell>
                  <TableCell sx={{ color: log.loginSuccess ? "#49D890" : "#FF5A67", fontWeight: "bold" }}>
                    {log.loginSuccess ? "성공" : "실패"}
                  </TableCell>
                  <TableCell sx={{ color: "#fff" }}>{log.ipAddress}</TableCell>
                  <TableCell sx={{ color: "#fff" }}>{log.browser}</TableCell>
                  <TableCell sx={{ color: "#fff" }}>{log.os}</TableCell>
                  <TableCell sx={{ color: "#fff" }}>{log.deviceType}</TableCell>
                  <TableCell sx={{ color: "#fff" }}>
                    {new Date(log.createdAt).toLocaleString()}
                  </TableCell>
                  <TableCell sx={{ color: "#fff" }}>{log.memo}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
  
        {/* 페이지네이션 */}
        <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
          <Pagination
            count={pageCount}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />
        </div>
      </div>
  );
};

export default LogSystem;